import {
  Cluster,
  DefaultRenderer,
  Marker,
  MarkerClusterer,
} from "@googlemaps/markerclusterer";
import { useCallback, useContext, useEffect, useState } from "react";
import { AdvancedMarker, Map, useMap } from "@vis.gl/react-google-maps";
import { GetDataForMapsResult } from "../masters/items/queries/types";
import { CustomModal } from "../../../../utils/UtilFunctions";
import {
  ViewAssetStyles,
  ViewModalStyles,
  ViewRaisedTicketModalStyles,
} from "../../../../styles/CustomModalStyles";
import { empType } from "../../../../utils/Enum.types";
import { MapProps } from "./MyMaps";
import MapHandler from "./MapHandler";
import { MapsContext } from "../maps/context/context";
import { mapsPayloadType } from "../maps/context/reducer";
import { EMPTY_STRING, TicketStatus } from "../../../../utils/constants";
import { AppContext } from "../../../../context/context";
import JunctionLevelTicketing from "../maps/ticketing/junctionDetails/JunctionIndex";
import { payloadTypes } from "../../../../context/reducer";
import { TableType } from "../../customer/companies/queries/types";
import RaisedTicketDetails from "../maps/ticketing/junctionDetails/raisedTickets/RaisedTicketDetails";
import { CustomTooltip } from "../../../../styles/TooltipStyles";
import { TOOLTIP_COLORS } from "../../../../styles/Variables";
import useLabels from "../../../../customHooks/useLabels";
import { StateTypes } from "../maps/Maps";
import { AssetDetailsPageFor } from "../maps/ticketing/junctionDetails/raisedTickets/AssetDetails";
import CoordinatesSearch from "./CoordinatesSearch";

export interface longLatPos {
  lat: number;
  lng: number;
}

type PointsProp = {
  points: GetDataForMapsResult[];
};
type Tree = {
  key: string;
  name: string;
  lat: number;
  lng: number;
};

export class CustomRenderer extends DefaultRenderer {
  render(cluster: Cluster) {
    const count = cluster.count;
    const position = cluster.position;

    const raisedCount = cluster.markers
      ? cluster.markers.filter((m) => {
          if (
            m &&
            (m as HTMLElement).childNodes.length &&
            (m as HTMLElement).childNodes[0].childNodes.length &&
            (m as HTMLElement).childNodes[0].childNodes[0].childNodes.length
          ) {
            const element = (m as HTMLElement).childNodes[0].childNodes[0]
              .childNodes[0] as HTMLElement;

            return element.className.includes("status__open");
          } else return false;
        })
      : [];

    const bgColor = raisedCount.length > 0 ? "red" : "green";

    // Create a custom div element for the cluster
    const div = document.createElement("div");
    div.style.backgroundColor = bgColor;
    div.style.color = "white";
    div.style.borderRadius = "50%";
    div.style.width = "40px";
    div.style.height = "40px";
    div.style.display = "flex";
    div.style.alignItems = "center";
    div.style.justifyContent = "center";

    div.className =
      raisedCount.length > 0 ? "clusterer-blink" : "clusterer-unblink";
    div.innerHTML = `<strong>${count}</strong>`;

    return new google.maps.marker.AdvancedMarkerElement({
      position,
      content: div,
    });
  }
}

interface idStatus {
  id: number;
  ticketStatus: TicketStatus;
}

const MapsView = ({
  items,
  clusterer,
  selectedPlace,
  assetType,
  searchCoordinates,
  showIconFlag,
}: MapProps) => {
  const { dispatch } = useContext(MapsContext);
  const { dispatch: globalDispatch, state: globalState } =
    useContext(AppContext);

  const {
    companyLabel,
    subsidiaryLabel,
    itemLabel,
    junctionLabel,
    subsidiarySiteLabel,
  } = useLabels();
  const [assetDetails, setAssetdetails] = useState<StateTypes>({
    itemId: 0,
    flag: false,
    tableLevel: TableType.COMPANY,
  });
  const [raisedTicketModal, setRaisedTicketModal] = useState<StateTypes>({
    itemId: 0,
    flag: false,
    tableLevel: TableType.COMPANY,
  });

  const defaultCenter = {
    lat: 12.981010391578677,
    lng: 77.60151962452281,
  };

  const Markers = ({ points }: PointsProp) => {
    const map = useMap();
    const [markers, setMarkers] = useState<{
      [key: string]: { marker: Marker; idStatus: idStatus };
    }>({});

    useEffect(() => {
      clusterer.current = null;
    }, []);
    useEffect(() => {
      if (!map) return;
      if (!clusterer.current)
        clusterer.current = new MarkerClusterer({
          map,
          // renderer: new CustomRenderer(),
        });
    }, [map, points]);

    useEffect(() => {
      clusterer.current?.clearMarkers();

      Object.values(markers).forEach((mark) => {
        clusterer.current?.addMarkers(Object.values(mark.marker));
      });
    }, [markers, points]);

    // useEffect(() => {
    //   Object.values(markers).forEach((marker, index) => {
    //     if (marker) {
    //       // marker.marker.customData = markersData[index]; // Assign data
    //       marker.marker.addListener("gmp-click", () => {
    //         clusterer.current?.clearMarkers();

    //         // dispatch({
    //         //   type: mapsPayloadType.ASSET,
    //         //   payload: {
    //         //     asset: {
    //         //       label: "",
    //         //       value: marker.idStatus.id,
    //         //     },
    //         //   },
    //         // });
    //         dispatch({
    //           type: mapsPayloadType.ASSET_TYPE_ID,
    //           payload: {
    //             assetTypeId: marker.idStatus.id,
    //           },
    //         });

    //         // globalDispatch({
    //         //   type: payloadTypes.SET_COMPANY_ID,
    //         //   payload: {
    //         //     companyId: curCompanyID,
    //         //   },
    //         // });

    //         if (marker.idStatus.ticketStatus === TicketStatus.CLOSED) {
    //           setAssetdetails((prev) => ({
    //             ...prev,
    //             flag: true,
    //             itemId: marker.idStatus.id,
    //           }));
    //         } else {
    //           setRaisedTicketModal((prev) => ({
    //             ...prev,
    //             flag: true,
    //             itemId: marker.idStatus.id,
    //           }));
    //         }
    //       });
    //     }
    //   });
    // }, []);

    const getAssetTypeLabel = useCallback(() => {
      switch (assetType) {
        case TableType.ASSET:
          return itemLabel;
        case TableType.JUNCTION:
          return junctionLabel;
        case TableType.COMPANY:
          return companyLabel;
        case TableType.SUBSIDIARY:
          return subsidiaryLabel;
        case TableType.SITE:
          return subsidiarySiteLabel;
        default:
          return EMPTY_STRING;
      }
    }, [
      assetType,
      itemLabel,
      junctionLabel,
      companyLabel,
      subsidiaryLabel,
      subsidiarySiteLabel,
    ]);

    return (
      <>
        {points.map(
          (
            {
              latitude,
              longitude,
              companyID,
              id,
              icon,
              ticketStatus,
              desc,
              name,
              address,
            },
            key
          ) => {
            const itemPoint: Tree = {
              key: JSON.stringify({
                id,
                latitude,
                longitude,
              }),
              lat: Number(latitude),
              lng: Number(longitude),
              name: id.toString(),
            };

            const img = require(`${process.env.React_App_Display_Map_Icons}/${
              icon ? icon : "item"
            }.svg`);

            return (
              <AdvancedMarker
                key={key}
                position={itemPoint}
                // ref={(marker) =>
                //   handleRefs(
                //     marker,
                //     {
                //       id,
                //       ticketStatus,
                //     },
                //     key
                //   )
                // }
                zIndex={ticketStatus === TicketStatus.OPEN ? 4 : 1}
                onClick={() => {
                  if (assetType === TableType.JUNCTION) {
                    dispatch({
                      type: mapsPayloadType.ASSET_TYPE_ID,
                      payload: {
                        assetTypeId: id,
                      },
                    });
                    dispatch({
                      type: mapsPayloadType.ASSET_TYPE_ID,
                      payload: {
                        assetTypeId: id,
                      },
                    });
                    dispatch({
                      type: mapsPayloadType.COMPANY_ID,
                      payload: {
                        companyId: companyID,
                      },
                    });

                    globalDispatch({
                      type: payloadTypes.SET_COMPANY_ID,
                      payload: {
                        companyId: companyID,
                      },
                    });

                    if (ticketStatus === TicketStatus.CLOSED) {
                      setAssetdetails((prev) => ({
                        ...prev,
                        flag: true,
                        itemId: id,
                      }));
                    } else {
                      setRaisedTicketModal((prev) => ({
                        ...prev,
                        flag: true,
                        itemId: id,
                      }));
                    }
                    clusterer.current?.clearMarkers();
                  }
                }}
                className={`marker feature status__${ticketStatus.toLocaleLowerCase()}`}
              >
                <CustomTooltip
                  title={
                    <>
                      {name} <br></br> {address}
                    </>
                  }
                  arrow
                  placement="top"
                  slotProps={{
                    tooltip: {
                      sx: {
                        bgcolor: TOOLTIP_COLORS.VARIABLE,
                        "& .MuiTooltip-arrow": {
                          color: TOOLTIP_COLORS.VARIABLE,
                        },
                      },
                    },
                  }}
                >
                  <img
                    src={img}
                    className={`marker-img .status__${ticketStatus.toLocaleLowerCase()}`}
                    alt="Image not found"
                  />
                </CustomTooltip>
                {/* {item.icon !== "pin.svg" ? ( */}
                <></>
                {/* ) : (
                <Pin></Pin>
              )} */}
                <div
                  className={`tip status__${ticketStatus.toLocaleLowerCase()}`}
                ></div>
              </AdvancedMarker>
            );
          }
        )}
      </>
    );
  };

  return (
    <>
      <div className="map-view">
        <Map
          defaultZoom={13}
          defaultCenter={defaultCenter}
          mapId={process.env.React_App_Map_ID}
          disableDefaultUI={true}
          gestureHandling={"greedy"}
        >
          <Markers points={items} />
          <MapHandler
            place={selectedPlace}
            searchCoordinates={searchCoordinates}
          />
          {showIconFlag ? (
            <CoordinatesSearch searchCoordinates={searchCoordinates} />
          ) : null}
        </Map>
      </div>
      <CustomModal
        style={ViewAssetStyles}
        isOpen={assetDetails.flag}
        onRequestClose={() => {}}
        contentComponent={
          // <Ticketing
          //   setModalFlag={() =>
          //     setAssetdetails({
          //       flag: false,
          //       itemId: 0,
          //     })
          //   }
          //   showRaiseTicket={globalState.empSubType !== empType.TECHNICIAN}
          // />
          <JunctionLevelTicketing
            setModalFlag={setAssetdetails}
            assetType={assetType}
            showRaiseTicket={globalState.empSubType !== empType.TECHNICIAN}
          />
        }
      />

      <CustomModal
        style={ViewRaisedTicketModalStyles}
        isOpen={raisedTicketModal.flag}
        onRequestClose={() =>
          setRaisedTicketModal({
            flag: false,
            itemId: 0,
            tableLevel: TableType.COMPANY,
          })
        }
        contentComponent={
          <RaisedTicketDetails
            setModalFlag={() =>
              setRaisedTicketModal({
                flag: false,
                itemId: 0,
                tableLevel: TableType.CUSTOMER,
              })
            }
            assetType={assetType}
            pageFor={AssetDetailsPageFor.MAPS}
          />
        }
      />

      {/* <CustomModal
        style={ViewItemModalStyles}
        isOpen={companyDetails}
        onRequestClose={() => setCompanyDetails(!companyDetails)}
        contentComponent={<CompanyDetails setModalFlag={setCompanyDetails} />}
      /> */}
    </>
  );
};

export default MapsView;
